<app-page-wrapper scrollable="true">
    <div class="membership-wrapper">
        <app-heavy-header *ngIf="!isAircraftOnlyEdit"
            [title]="isEditing ? 'Edit Membership' : 'Your Membership'"></app-heavy-header>
        <app-heavy-header *ngIf="isAircraftOnlyEdit" title="Edit Aircraft"></app-heavy-header>

        <form (ngSubmit)="submit(form)" #form="ngForm" class="membership-form" style="display: block;">

            <div class="field-row" *ngIf="!isAircraftOnlyEdit">
                <div class="field-set lg">
                    <div class="set-label">Membership</div>
                    <app-base-select id="provider" name="provider" placeholder="Select Provider"
                        [(ngModel)]="membershipProvider" [options]="membershipProviders" isFluid="true" required
                        [disabled]="isEditing"></app-base-select>
                </div>
                <div class="field-set md">
                    <div class="set-label">Type</div>
                    <app-base-select id="type" name="type" placeholder="Select Type" [(ngModel)]="membershipType"
                        [options]="membershipTypes" displayField="name" isFluid="true" required></app-base-select>
                </div>
            </div>

            <div class="field-row">
                <div class="field-set xl" *ngIf="!isOtherAircraft">
                    <div class="set-label">Aircraft</div>
                    <app-base-select id="defaultAircraft" name="defaultAircraft" placeholder="Select an aircraft"
                        [(ngModel)]="defaultAircraft" (ngModelChange)="onSelectAircraft($event)"
                        [options]="aircraftOptions" displayField="name" isFluid="true" required
                        #aircraftModel="ngModel">
                    </app-base-select>
                </div>
                <div class="field-set xl" *ngIf="isOtherAircraft">
                    <div class="label-row">
                        <div class="set-label">Other Aircraft</div>
                        <div class="cancel-text" (click)="viewList()">Show List</div>
                    </div>
                    <app-base-input id="otherAircraft" name="otherAircraft" placeholder="Enter aircraft name" mb="14px"
                        [(ngModel)]="otherAircraft" isFluid="true" required autocomplete="off"></app-base-input>
                </div>
                <div class="field-set sm">
                    <div class="set-label">Seats</div>
                    <app-base-input id="seatingConfiguration" placeholder="Seating Configuration" mb="14px"
                        [(ngModel)]="seatingConfiguration" name="seatingConfiguration" type="number" isFluid="true"
                        autocomplete="off"></app-base-input>
                </div>
            </div>

            <div class="setting-section" *ngIf="showPrefs">
                <app-section-label weight="700" size="16px" mb="14px">When I fly</app-section-label>

                <div class="pref-rows">
                    <ng-container *ngFor="let pref of preferences">
                        <app-toggle-row [setting]="pref.key" [description]="pref.prefLabel" settingVariant="preference"
                            [checked]="pref.preference" (settingChange)="onPrefToggle($event)">
                        </app-toggle-row>

                        <app-toggle-row [setting]="pref.key" [description]="pref.usageLabel" settingVariant="usage"
                            [checked]="pref.usage" (settingChange)="onPrefToggle($event)">
                        </app-toggle-row>
                    </ng-container>
                </div>
            </div>

            <!-- Error/message -->
            <app-alert-message *ngIf="error" type="error" mb="12px">{{ error }}</app-alert-message>

            <!-- Submit Button -->
            <app-primary-btn [disabled]="isLoading" [isLoading]="isLoading" gradient="true" mt="8px">
                Save Membership
            </app-primary-btn>

            <app-text-button *ngIf="!isEditing" (handleClick)="onClickBack()" mt="14px"
                text="Go Back"></app-text-button>
        </form>
    </div>
</app-page-wrapper>